import { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import { Redirect } from 'react-router-dom/cjs/react-router-dom'

import Error404 from '../ui/views/errors/Error404'
import Loader from '../ui/views/Loader'
import * as routes from '../routes'
import ProtectedRoute from './ProtectedRoute'
import { SHIPPINGS_RECORDING_USERS } from '../common/constants'

const Home = lazy(() => import('../App/Home'))
const ShippingSend = lazy(() => import('../context/ShippingSend'))
const ShippingsTracking = lazy(() => import('../App/ShippingsTracking'))
const Help = lazy(() => import('../context/Help'))
const PrintSettings = lazy(() => import('../App/PrintSettings'))
const Downloads = lazy(() => import('../context/DownloadInstallJSPMApp'))
const Billing = lazy(() => import('../App/Billing'))
const UserZone = lazy(() => import('../App/UserZone'))
const ShippingDetail = lazy(() => import('../context/ShippingDetail'))
const ShippingsRecording = lazy(() => import('../App/ShippingsRecording'))
const Agenda = lazy(() => import('../App/Agenda'))
const Reports = lazy(() => import('../App/Reports'))
const MyClients = lazy(() => import('../App/MyClients'))
const ClientDetail = lazy(() => import('../App/MyClients/ClientDetail'))

const DesktopRouter = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route exact path="/home">
          <Redirect to={routes.HOME.path} />
        </Route>

        <Route exact path={routes.HOME.path}>
          <Home />
        </Route>

        <Route exact path={routes.SHIPPING_SEND.path}>
          <ShippingSend />
        </Route>

        <Route exact path={routes.SHIPPING_DETAIL.path}>
          <ShippingDetail />
        </Route>

        <Route exact path={routes.SHIPPINGS_TRACKING.path}>
          <ShippingsTracking />
        </Route>

        <Route exact path={routes.SHIPPINGS_RECORDING.path}>
          <ShippingsRecording />
        </Route>

        {/* <ProtectedRoute
        exact
        path={routes.SHIPPINGS_RECORDING.path}
        component={ShippingsRecording}
        allowedUserCodes={SHIPPINGS_RECORDING_USERS}
      /> */}

        <Route exact path={routes.HELP.path}>
          <Help />
        </Route>

        <Route exact path={routes.PRINT_SETTINGS.path}>
          <PrintSettings />
        </Route>

        <Route exact path={routes.DOWNLOADS.path}>
          <Downloads />
        </Route>

        <Route exact path={routes.BILLING.path}>
          <Billing />
        </Route>

        <Route exact path={routes.USER_ZONE.path}>
          <UserZone />
        </Route>

        <Route exact path={routes.AGENDA.path}>
          <Agenda />
        </Route>

        <Route exact path={routes.REPORTS.path}>
          <Reports />
        </Route>

        <Route exact path={routes.MY_CLIENTS.path}>
          <MyClients />
        </Route>

        <Route exact path={routes.MY_CLIENTS_DETAIL.path}>
          <ClientDetail />
        </Route>

        <Route component={Error404} />
      </Switch>
    </Suspense>
  )
}

export default DesktopRouter
